/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { Menu } from 'semantic-ui-react';
import classNames from 'classnames';
import { logout } from 'Redux/modules/auth/actions';
import { toggleSidebar } from 'Redux/modules/ui/actions';
import { unregisterNotificationTokenConsult } from 'Redux/modules/webChat/actions';
import { shouldEnableAppointment } from 'Containers/Appointment/utils';
import useClinic from 'Containers/Home/hooks/useClinic';
import { useCurrentClinic } from 'Containers/Home/hooks/useCurrentClinic';

import style from './Sidebar.less';
import MenuTree from './MenuTree/MenuTree';
import menuItemsData from './MenuData';

const superUsers = ['tysiaw@gmail.com', 'info@punggolripplesfamilyclinic.com'];

const loopAndCheck = (arr, allowedItems = []) => {
  const newArr = arr
    .map(item => {
      if (allowedItems.includes(item.name)) {
        const newItem = { ...item };

        if (item.children) {
          newItem.children = loopAndCheck(item.children, allowedItems);
        }

        return newItem;
      }
      return null;
    })
    .filter(x => x !== null);

  return newArr;
};

const validateRole = (user, clinics) => {
  let allowed = [];

  allowed = [
    'home',
    'lab',
    'web-chat',
    'bpdata',
    'prescriptions',
    'patients',
    'management',
    'user',
    'role',
    'permission',
    'clinic',
    'settings',
  ];
  if (shouldEnableAppointment(user.accountId, clinics)) {
    allowed.push('appointments');
    allowed.push('working-calendar');
  }

  if (user.email && superUsers.includes(user.email.toLowerCase())) {
    allowed.push('emr');
  }

  return loopAndCheck(menuItemsData, allowed);
};

const renderMenuItems = (user, collapsed, clinics) => {
  const menuItems = validateRole(user, clinics);
  return (
    <div className={style.mainMenu}>
      <MenuTree items={menuItems} collapsed={collapsed} />
    </div>
  );
};

const Sidebar = props => {
  const { collapsed, user } = props;

  const menuProps = {
    inverted: true,
    vertical: true,
    icon: collapsed,
    className: classNames([style.sidebarWrapper], { [style.collapsed]: collapsed }),
  };

  const profile = useSelector(state => state.doctors.profile);
  const { clinics, getClinics } = useClinic(user.accountId);
  const { saveCurrentClinic } = useCurrentClinic();

  // Check when doctors enter page
  useEffect(() => {
    saveCurrentClinic(profile?.primaryClinic?.id);
  }, [profile?.id]);

  useEffect(() => {
    getClinics();
  }, []);

  return (
    <Menu {...menuProps}>
      <div className={style.wrapMenuItem}>{renderMenuItems(user, collapsed, clinics)}</div>
      {/* <ClinicSelector collapsed={collapsed} /> */}
    </Menu>
  );
};

const mapStateToProps = state => ({
  user: state.auth.data,
  collapsed: state.ui.isSidebarCollapsed,
});

const mapDispatchToProps = {
  logout,
  toggleSidebar,
  unregisterNotificationTokenConsult,
};

Sidebar.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
